import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
export class UserServiceModel {
  userId!: string | null;
}
@Injectable()
export class UserIdInterceptor implements HttpInterceptor {

  constructor(private userService: UserServiceModel) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!request.params.has('userId') && this.userService.userId) {
      return next.handle(request.clone({
        params: request.params.set('userId', this.userService.userId)
      }));
    }
    return next.handle(request);
  }
}
